// Environment-specific configuration
const getEnvironmentConfig = () => {
  // Check if running in Cloudflare Pages production environment
  if (process.env.CF_PAGES && process.env.NODE_ENV === 'production') {
    return {
      baseUrl: 'https://safehaven.chat',  // Production URL
      apiUrl: 'https://safehaven.chat'    // Production API URL
    };
  }
  
  // Check if running in Cloudflare Pages preview environment (e.g., PR deployments)
  if (process.env.CF_PAGES && process.env.CF_PAGES_BRANCH !== 'main') {
    return {
      baseUrl: process.env.CF_PAGES_URL,  // Dynamic preview URL
      apiUrl: process.env.CF_PAGES_URL    // Dynamic preview URL for Functions
    };
  }

  // Local development
  return {
    baseUrl: 'http://localhost:3000',  // Vite dev server
    apiUrl: 'http://localhost:8788'    // Local Cloudflare Pages Functions
  };
};

const config = getEnvironmentConfig();

// API endpoints
export const API_ENDPOINTS = {
  chat: `${config.apiUrl}/api/chat`,
  analyzeImage: `${config.apiUrl}/api/analyze-image`,
};

// Frontend configuration
export const FRONTEND_CONFIG = {
  baseUrl: config.baseUrl
};
